// extracted by mini-css-extract-plugin
export const contactListings = "contact-module--contact-listings--36dqq";
export const listing = "contact-module--listing--xtAzU";
export const listing__icon = "contact-module--listing__icon--3IyKD";
export const listing__text = "contact-module--listing__text--d4-D_";